import { TextField } from '@material-ui/core';
import { BaseModalContainer } from '@styles/container-styles';
import styled from 'styled-components';

export const OtherReasonTextArea = styled(TextField).attrs(
    {
        multiline: true,
        rows: 3,
        rowsMax: 3,
        fullWidth: true,
        variant: 'outlined'
    }
)`
  /* Intentionally left blank */
`;

export const DeclineModalContainer = styled(BaseModalContainer)`
  /* intentionally left blank */
`;



// WEBPACK FOOTER //
// ./src/containers/decline-modal/styles.tsx